module.exports = "/packs/images/svg/ireland/facilities/health_suite~34696772de2b5cd8623d14fc77ba1abc.svg";